
























import { Component, Vue } from "vue-property-decorator";
import VChartRow from "./VChartRow.vue";

@Component({
  components: {
    VChartRow
  }
})
export default class VChartOperator extends Vue {}
